import { ArrowUpRight, List } from "@phosphor-icons/react";
import { useState } from "react";
import { FlexRow } from "../Flex/FlexRow";
import { DivisorX } from "../Outros/DivisorX";
import { CX } from "../Tags/ConteudoX";
import { TX } from "../Tags/TextoX";

interface INavbar {
  texto: string;
  rota: string;
}

interface IHeader {
  imagem?: string;
  titulo?: string;
  navbar?: INavbar[];
}

export const Header = ({ imagem, titulo, navbar }: IHeader) => {
  const [menuAberto, setMenuAberto] = useState(false);

  return (
    <>
      <CX
        tipo="header"
        className={`
        fixed top-0 z-40 flex h-fit w-full justify-between bg-white px-2 py-2 sm:px-8 md:relative md:h-[88.35px] md:px-10 md:pt-0
        `}
      >
        {imagem && (
          <a href="/" title="Santana Cred">
            <img
              src={imagem}
              alt={titulo}
              className={`
              h-[56px]
              w-[47.98]
              md:h-[86.35px]
          `}
            />
          </a>
        )}
        {navbar && (
          <>
            <FlexRow className={`hidden gap-2 md:flex`}>
              {navbar.map(({ texto, rota }: INavbar, key: number) => (
                <a key={key} href={rota}>
                  <TX
                    tipo="p"
                    className={`
                    p-2
                    text-16
                    font-semibold
                    text-black
                    hover:text-primaria-claro
                    `}
                  >
                    {texto}
                  </TX>
                </a>
              ))}
              <p className="flex items-center border-b border-primaria-claro pb-2 font-semibold text-primaria-claro">
                <a
                  href="https://wa.me/553432259969"
                  rel="nofollow noreferrer"
                  target="_blank"
                  title="Fale Conosco"
                  className="flex items-center gap-2"
                >
                  Fale Conosco <ArrowUpRight size={20} />
                </a>
              </p>
            </FlexRow>

            <FlexRow className={`flex items-center justify-center px-4 md:hidden`}>
              <CX tipo="div" className="relative inline-block w-auto pt-1 duration-300">
                <button
                  onClick={() => setMenuAberto(!menuAberto)}
                  onBlur={() =>
                    setTimeout(() => {
                      setMenuAberto(false);
                    }, 100)
                  }
                  className={`navbar_mobile_botao-claro rounded-6`}
                >
                  <List
                    weight="bold"
                    className={`
                    h-7
                    w-7
                    text-black
                    `}
                  />
                </button>
                {menuAberto && (
                  <div
                    className={`fixed inset-0 z-50 transform bg-black bg-opacity-75 transition-transform duration-300 ${
                      menuAberto ? "translate-x-0" : "-translate-x-full"
                    }`}
                  >
                    <div className="flex justify-end p-4">
                      <button onClick={() => setMenuAberto(false)} className="text-2xl text-white">
                        X
                      </button>
                    </div>
                    <div className="flex h-full flex-col items-center justify-center">
                      <DivisorX />
                      {navbar.map(({ texto, rota }, key) => (
                        <>
                          <a key={key} href={rota} className="my-2">
                            <p
                              className={`
                            p-2
                            text-30
                            font-semibold
                            text-white
                            hover:text-primaria-claro
                          `}
                            >
                              {texto.toUpperCase()}
                            </p>
                          </a>
                          <DivisorX />
                        </>
                      ))}
                    </div>
                  </div>
                )}
              </CX>
            </FlexRow>
          </>
        )}
      </CX>
    </>
  );
};
